/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export const closingTypeToDisplay = {
  HYBRID: 'Hybrid',
  RON: 'Remote Online Notary',
  TRADITIONAL: 'Traditional',
  UNDETERMINED: 'Undetermined'
};
export const RONSelectionCopy = {
  NOTARY_CAM: '(using Blend)',
  OTHER: '(using Other)'
};
export const HAWAII_TIMEZONE = 'Pacific/Honolulu';
export const REMEMBER_MFA_DEVICE_COOKIE = 'remember_mfa_device_id';
export let RoleName = /*#__PURE__*/function (RoleName) {
  RoleName["BLEND_NOTARY"] = "Blend Notary";
  RoleName["BSR_ADMIN"] = "BSR Admin";
  return RoleName;
}({});